import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function RequireVendor({ children, redirectTo = '/login' }) {
  const { id } = useParams();
  const { auth } = useAuth();

  if (!auth.initialized) {
    return null;
  }

  const isAdmin = auth.loggedIn && auth.userData.admin;
  const isCateringUser = !isAdmin && auth.loggedIn && auth.userData.catering_user;
  const isVendorUser = !isAdmin && !isCateringUser && auth.loggedIn;

  let redirectLink = redirectTo;
  if (isCateringUser) {
    redirectLink = '/catering/dashboard';
  }

  // Check that this vendor owns this truck
  let vendorOwnsTruck = true;
  if (isVendorUser && id) {
    vendorOwnsTruck = auth.userData.trucks.some((truck) => truck.slug === id);
  }

  if (isVendorUser && !vendorOwnsTruck) {
    redirectLink = '/vendor';
  }

  return (isAdmin || (isVendorUser && vendorOwnsTruck)) ? children : <Redirect to={redirectLink}/>;
}

export default RequireVendor;
